import { Box } from '@chakra-ui/react';

import styles from './styles.module.css';

const Bento = ({ children, className = '' }) => {
  return <Box className={`${styles['bento__container']} ${className}`}>{children}</Box>;
};

export default Bento;
